import { Box } from '@mui/material'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import ConfigManager from 'components/config/ConfigManager'
import Contenitore from 'components/ui/Contenitore'
import Testo from 'components/ui/Testo'
import Titolone from 'components/ui/Titolone'
import { PASS_HEADER } from 'configuration/pass'

const CFG = PASS_HEADER

export default function PassContenitore(props) {
  const { children, noHeader = false } = props

  return (
    <Contenitore>
      {!noHeader &&
        <ConfigManager
          elenchiConfig={[ELENCHI.CFG_PASS_HEADER]}
          render={({ txt }) =>
            <>
              <Titolone>{txt(CFG.TITOLO)}</Titolone>
              <Titolone>{txt(CFG.SOTTOTITOLO)}</Titolone>
              <Testo>{txt(CFG.DESCRIZIONE)}</Testo>
            </>
          }
        />
      }
      <Box sx={{ mt: 4, ml: { sm: 2, lg: 4 } }}>
        {children}
      </Box>
    </Contenitore>
  )
}